import React from "react";
import "./InnovationLatinoCoalitionSection.scss";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import TwoColumnLayout from "../components/TwoColumnLayout";
import LC_IMAGE from "../assets/images/latino-coalition.png";

const InnovationLatinoCoalitionSection: React.FC = () => {
  const leftContent = (
    <div className="innovation-latino-coalition-section-content">
      <p>
        As a community-facing intermediary, the Latino Coalition for Community
        Leadership (LCCL) bridges government and philanthropic resources with
        grassroots organizations rooted in communities most impacted by poverty,
        violence, and incarceration. Their model focuses on building
        organizational infrastructure, strengthening leadership, and equipping
        community and faith-based nonprofits with the tools to thrive. 
      </p>
      <p>
        Since 2004, LCCL has partnered with more than 237 community
        organizations across 10 states to expand their capacity. Over this time,
        they have managed more than $154 million in government and philanthropic
        funding, directing those resources deeply into communities that would
        otherwise have little to no access to traditional funding streams. Many
        of these grassroots organizations have since grown into
        multimillion-dollar nonprofits, now serving hundreds of individuals each
        year.
      </p>
      <p>
        Because of their trusted relationships with partners and deep
        understanding of their operations, LCCL has also been able to respond
        effectively in times of crisis. For example, during the COVID-19
        pandemic, they provided targeted grants, cash flow assistance, and
        infrastructure support, while also facilitating cross-sector
        communication and coordination. These efforts strengthened
        organizational stability and helped prevent disruption of vital services
        to communities most in need.
      </p>
    </div>
  );

  const rightContent = (
    <div className="innovation-latino-coalition-section-right-content">
      <img src={LC_IMAGE} alt="" className="lc-image" />
    </div>
  );

  return (
    <ContentSection className="innovation-latino-coalition-section">
      <SectionHeader
        title="Highlights from the field"
        description="Lessons from an Intermediary"
      />
      <span>By Richard Morales</span>
      <br />
      <span style={{ fontWeight: 100, fontSize: 14 }}>
        President & CEO, Latino Coalition for Community Leadership
      </span>
      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />
    </ContentSection>
  );
};

export default InnovationLatinoCoalitionSection;
